/** @deprecated use new brand color variables */
export var colors = {
  brandBlueDark: '#074879',
  brandBlueLight: '#cce7ff',
  brandBluePrimary: '#0c78ca',
  brandOrangeDark: '#792007',
  brandOrangeLight: '#eccfc9',
  brandOrangePrimary: '#ca360c',
  brandPinkDark: '#790745',
  brandPinkLight: '#ecc7dd',
  brandPinkPrimary: '#ca0c73',
  brandPurpleDark: '#490779',
  brandPurpleLight: '#dcc7ef',
  brandPurplePrimary: '#7a0cca',
  functionalGreenDark: '#093d00',
  functionalGreenLight: '#c4dec0',
  functionalGreenPrimary: '#127a00',
  functionalRedDark: '#64000f',
  functionalRedlight: '#f1c0c7',
  functionalRedPrimary: '#c9001e',
  functionalYellowDark: '#74600c',
  functionalYellowLight: '#f9efc5',
  functionalYellowPrimary: '#e8c118',
  neutralDark: '#465967',
  neutralDarker: '#021828',
  neutralLight: '#aebcc6',
  neutralLighter: '#eef1f3',
  neutralPrimary: '#7b8a94',
  neutralWhite: '#ffffff'
};